export class BonuspunktprogrammStufe {
  AbBonuspunktSaldo: number;
  GutschriftProzent: string;

  // GUI
  level: number;
}
